import {getApiUrl} from "./client";
import {HOTSPOT_DETAIL_ENDPOINT} from "./constants";
import type {HotspotExplorerHotspot} from "../views/hotspot-explorer/types";

export type HotspotDetailResponse = {
    status: string,
    hotspot: HotspotExplorerHotspot & {
        latitude?: number | null,
        longitude?: number | null,
        visitState?: 'visited' | 'not_visited'
    }
};

export const getHotspotDetail = async (locationId: string) => {
    const response = await fetch(getApiUrl(`${HOTSPOT_DETAIL_ENDPOINT}/${encodeURIComponent(locationId)}`), {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    });

    if (!response.ok) {
        let message = `Hotspot detail failed with ${response.status}`;

        try {
            const payload = await response.json();
            if (payload?.message) {
                message = payload.message;
            }
        } catch (error) {
            // Ignore parse errors and surface the HTTP status instead.
        }

        throw new Error(message);
    }

    return await response.json() as HotspotDetailResponse;
};
